import axios from "axios";
import { ValidationException } from "@/store/user/model/user";
import auth from "@/store/user/module/auth";
import common from './common';

const baseUrl = "/";

export const httpApi = axios.create({
  baseURL: baseUrl,
  timeout: 2000,
});

httpApi.defaults.timeout = 2000;

export function setAuthHeader(token: string) {
  httpApi.defaults.headers.common["Authorization"] = token;
}

export function clearAuthHeader() {
  delete httpApi.defaults.headers.common["Authorization"];
}

function headersCT(cancelToken) {
  const headers = {
    headers: { "x-api-key": "web" },
    cancelToken: cancelToken,
  };
  if (auth) {
    //console.log(auth.authToken);
    if (auth.token) {
      headers.headers["Authorization"] = auth.token;
    }
  }
  return headers;
}

function headers() {
  const headers = {
    headers: { 
      "responseType": 'blob',   
      "x-api-key": "web",
      "Content-Type": "application/json"
    },
  };
  if (auth) {
    //console.log(auth.authToken);
    if (auth.token) {
      headers.headers["Authorization"] = auth.token;
    }
  }
  return headers;
}

function promiseReject(error) {
  if (
    error &&
    error.response &&
    error.response.status === 400 &&
    error.response.data
  ) {
    const exception = error.response.data as ValidationException;
    if (exception.customMessage) {
      exception.message = exception.message + " " + exception.customMessage;
    }
    return Promise.reject(error.response.data as ValidationException);
  } else if (error && error.response && error.response.status === 401) {
    auth.logout();
    return Promise.reject({
      status: error.response.status,
      message: "Unauthorized access.",
    } as ValidationException);
  }
  if (error.__CANCEL__) {
    return;
  }
  return Promise.reject({
    status: error.response.status,
    message: error.message,
  } as ValidationException);
}


async function downloadFileAxios(response) {
  
  const contentDisposition = response.headers["content-disposition"]; 
  //Retrieve file name from content-disposition
  let fileName = contentDisposition.substr(contentDisposition.indexOf("filename=") + 9);
  fileName = fileName.replace(/"/g, "");
  const contentType = response.headers["content-type"];
  //const ab = new TextEncoder().encode(response.data);
  const b = await response.data;
  const blob = new Blob([b], {type: contentType});

  //saveAs(blob, fileName); 

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName); //or any other extension
  document.body.appendChild(link);
  link.click();
  link.remove();
}

async function downloadFile(response) {
  
  const contentDisposition = response.headers.get("content-disposition"); 
  //Retrieve file name from content-disposition
  let fileName = contentDisposition.substr(contentDisposition.indexOf("filename=") + 9);
  fileName = fileName.replace(/"/g, "");
  const contentType = response.headers.get("content-type");
  //const ab = new TextEncoder().encode(response.data);
  const b = await response.blob();
  const blob = new Blob([b], {type: contentType});

  //saveAs(blob, fileName); 

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName); //or any other extension
  document.body.appendChild(link);
  link.click();
  link.remove();
}



export async function doGetCancel(url: string, cancelToken) {
  try {
    const response = await axios.get(url, headersCT(cancelToken));
    if (response.headers["content-disposition"]) {
      await downloadFileAxios(response);
    } else return response.data;
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doGet(url: string) {
  try {
    const heads = headers();
    const response = await axios.get(url, heads);
    if (response.headers["content-disposition"]) {
      await downloadFileAxios(response);
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doDelete(url: string) {
  try {
    const response = await axios.delete(url, headers());
    if (response.headers["content-disposition"]) {
      await downloadFileAxios(response);
    } else return response.data;
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doPost(url: string, payload) {
  try {
    const response = await axios.post(url, payload, headers());
    return response.data;
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}


export async function doGetWithDownload(url: string) {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers().headers,
    });
    // console.log("cddfd");
    
    if(response.headers.get("content-disposition")){
      await downloadFile(response);
    } else {
      return await response.json();
    } 
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doPostWithDownload(url: string, payload) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers().headers,
      body: JSON.stringify(payload)
    });
    // console.log("cddfd");
    if (response.headers.get("content-disposition")) {
      await downloadFile(response);
    } else {
      return await response.json();
    } 
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doPostFormWithDownload(url: string, payload: FormData) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: payload
    });
    // console.log("cddfd");
    if (response.headers.get("content-disposition")) {
      await downloadFile(response);
    } else {
      return await response.json();
    } 
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}

export async function doPostForm(url: string, payload: FormData) {
  try {
    const header = {...headers()};
    header.headers["content-type"] = `multipart/form-data;`;
    const response = await axios.post(url, payload, header);
    return response.data;
  } catch (error) {
    console.log(url);
    return promiseReject(error);
  }
}
